const SelfServiceIcon = ({ className, isSelected = false }) => {
  const fillColor = isSelected
    ? 'var(--forbrand-primary)'
    : 'var(--forbrand-secondary)'

  return (
    <div
      className={`${className} flex items-center justify-center w-[32px] h-[32px]`}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 26 26"
        xmlns="http://www.w3.org/2000/svg"
        fill={fillColor}
      >
        <path
          d="M13.5381 12.1875L9.95394 3.744C10.9135 3.42737 11.9357 3.25 13 3.25C17.7435 3.25 21.7015 6.656 22.5688 11.1499L23.9109 9.80785C22.5269 5.08601 18.1634 1.625 13 1.625C6.72774 1.625 1.625 6.72774 1.625 13C1.625 19.2723 6.72774 24.375 13 24.375C19.2723 24.375 24.375 19.2723 24.375 13C24.375 12.7258 24.3531 12.457 24.3338 12.1875H13.5381ZM3.25008 13C3.25008 9.26364 5.36478 6.01583 8.45788 4.37946L12.0576 12.8598L6.13633 19.9162C4.35549 18.1486 3.25008 15.7015 3.25008 13ZM13.0001 22.75C10.9085 22.75 8.97333 22.0819 7.38376 20.9564L13.3785 13.8125H22.7089C22.2938 18.8093 18.1023 22.75 13.0001 22.75Z"
          fill="#111113"
        />
      </svg>
    </div>
  )
}

export default SelfServiceIcon
